export default "__VITE_ASSET__DO8c0O64__"